import React, { useState, useEffect } from 'react';
import AuthUser from '../../../../../pageauth/AuthUser';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../Mensaje';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cargando from '../../../../../Cargando';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaPlus, FaBook, FaChartLine, FaFile, FaMoneyBill, FaSave } from 'react-icons/fa';

import CryptoJS from 'crypto-js';

export const RW_Combustibles_Combustibles = () => {
    require('../../Remotework.css?v=1.1.0');
    const navigate = useNavigate();
    const { SetMensaje } = Mensaje();
    const { StartCargando, StopCargando } = Cargando();
    const { ObtenerEstaciones, ObtenerCombustiblesPorEndpoint, EliminarCombustible, AgregarCombustible, ObtenerMangueras, RegistrarFuga, ObtenerFugas, EliminarFuga } = PuenteApi();
    const { getModule, getModuleSector, getApodoSector } = AuthUser();

    const [estaciones, setEstaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});
    const [combustiblesPorEstacion, setCombustiblesPorEstacion] = useState({});
    const [selectedView, setSelectedView] = useState("precios");
    const [nuevoCombustible, setNuevoCombustible] = useState({
        estacionId: "",
        nombre: "",
        precio: ""
    });
    const [fuga, setFuga] = useState({
        estacionId: "",
        aforadorId: "",
        cantidad: ""
    });
    const [mangueras, setMangueras] = useState([]);
    const [listaFugas, setListaFugas] = useState([]);
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    const [filtroFechas, setFiltroFechas] = useState({
        inicio: "",
        fin: ""
    });
    const [rangoMostrado, setRangoMostrado] = useState("Últimas 24 horas");

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        const estacionesGuardadas = localStorage.getItem("estaciones");

        if (estacionesGuardadas) {
            const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
            const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            setEstaciones(parsed);
            obtenerCombustiblesDeTodas(parsed);
        } else {
            obtenerEstaciones();
        }
    }, []);

    const obtenerEstaciones = async () => {
        try {
            setLoading(true);
            const response = await ObtenerEstaciones();

            if (response) {
                setEstaciones(response);
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
                await obtenerCombustiblesDeTodas(response);
            }
        } catch (error) {
            console.error("Error al obtener estaciones:", error);
        }
    };

    const obtenerCombustiblesDeTodas = async (listaEstaciones) => {
        const resultados = {};

        for (const estacion of listaEstaciones) {
            try {
                const response2 = await ObtenerCombustiblesPorEndpoint(estacion.endpoint);
                if (response2) {
                    const combustiblesFiltrados = response2.filter(c => c.nombre !== "Remotework");
                    resultados[estacion.id] = combustiblesFiltrados;
                } else {
                    resultados[estacion.id] = [];
                }
            } catch (error) {
                console.error("Error obteniendo combustibles de", estacion.nombre, error);
                resultados[estacion.id] = [];
            }
        }

        setCombustiblesPorEstacion(resultados);
        setLoading(false);
    };

    const handleToggle = (id) => {
        setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const eliminarCombustible = async (endpoint, combustibleId) => {
        Swal.fire({
            title: '¿Estás seguro?',
            html: "Se eliminará el combustible, los postnet y las mangueras asociadas.<br><br>¡Acción irreversible!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminarlo'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await EliminarCombustible(endpoint, { id: combustibleId });

                    if (response === true) {
                        Swal.fire({
                            title: 'Eliminado',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        obtenerCombustiblesDeTodas(estaciones);
                    } else {
                        Swal.fire({
                            title: 'Error',
                            html: response,
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                } catch (error) {
                    console.error("Error al eliminar combustible:", error);
                }
            }
        });
    };

    const handlePrecioChange = (estacionId, combustibleId, nuevoPrecio) => {
        setCombustiblesPorEstacion(prevState => {
            const newState = { ...prevState };
            const idx = newState[estacionId].findIndex(c => c.id === combustibleId);
            if (idx !== -1) newState[estacionId][idx].precio = nuevoPrecio;
            return newState;
        });
    };

    const handleActualizarPrecios = async () => {
        for (const estacionId in combustiblesPorEstacion) {
            const estacion = estaciones.find(e => e.id == estacionId);
            const combustibles = combustiblesPorEstacion[estacionId];
            console.log(estacion.endpoint, combustibles);
            // await ActualizarPrecioCombustible(estacion.endpoint, combustibles);
        }
        console.log(combustiblesPorEstacion);
    };

    const handleAgregarCombustible = async (e) => {
        e.preventDefault();
        if (!nuevoCombustible.estacionId || !nuevoCombustible.nombre || !nuevoCombustible.precio) {
            Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
            return;
        }

        const estacionSeleccionada = estaciones.find(e => e.id == nuevoCombustible.estacionId);
        if (!estacionSeleccionada) return;

        StartCargando("Guardando combustible...");
        const data = {
            nombre: nuevoCombustible.nombre,
            precio: nuevoCombustible.precio
        };

        const success = await AgregarCombustible(estacionSeleccionada.endpoint, data);

        if (success) {
            StopCargando();
            Swal.fire('Éxito', 'Combustible agregado correctamente', 'success');
            setNuevoCombustible({ estacionId: "", nombre: "", precio: "" });
            obtenerCombustiblesDeTodas(estaciones);
            setSelectedView("precios");
        } else {
            StopCargando();
        }
    };

    const handleEstacionFugaChange = async (e) => {
        const estacionId = e.target.value;
        setFuga({ ...fuga, estacionId: estacionId, aforadorId: "" });
        setMangueras([]);
        setListaFugas([]);
        setRangoMostrado("Últimas 24 horas");

        if (estacionId) {
            const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
            if (estacionSeleccionada) {
                StartCargando("Cargando datos...");
                const manguerasData = await ObtenerMangueras(estacionSeleccionada.endpoint);
                const fugasData = await ObtenerFugas(estacionSeleccionada.endpoint);
                StopCargando();
                if (manguerasData) {
                    setMangueras(manguerasData);
                }
                if (fugasData) {
                    setListaFugas(fugasData);
                }
            }
        }
    };

    const handleActualizarFugas = async (estacionId, filtros = {}) => {
        const estacionSeleccionada = estaciones.find(e => e.id == estacionId);
        if (estacionSeleccionada) {
            const fugasData = await ObtenerFugas(estacionSeleccionada.endpoint, filtros);
            if (fugasData) {
                setListaFugas(fugasData);
            }
        }
    }

    const handleFiltrarFugas = () => {
        if (filtroFechas.inicio && filtroFechas.fin) {
            handleActualizarFugas(fuga.estacionId, {
                fecha_inicio: filtroFechas.inicio,
                fecha_fin: filtroFechas.fin
            });
            setRangoMostrado(`Desde ${new Date(filtroFechas.inicio).toLocaleString()} hasta ${new Date(filtroFechas.fin).toLocaleString()}`);
        } else {
            Swal.fire('Atención', 'Debe seleccionar fecha de inicio y fin', 'warning');
        }
    };

    const handleRegistrarFuga = async (e) => {
        e.preventDefault();
        if (!fuga.estacionId || !fuga.aforadorId || !fuga.cantidad) {
            Swal.fire('Error', 'Todos los campos son obligatorios', 'error');
            return;
        }

        const estacionSeleccionada = estaciones.find(e => e.id == fuga.estacionId);
        if (!estacionSeleccionada) return;

        StartCargando("Registrando fuga...");
        const data = {
            aforador_id: fuga.aforadorId,
            cantidad: fuga.cantidad
        };

        const success = await RegistrarFuga(estacionSeleccionada.endpoint, data);

        if (success) {
            StopCargando();
            Swal.fire('Éxito', 'Fuga registrada correctamente', 'success');
            setFuga({ ...fuga, aforadorId: "", cantidad: "" });
            handleActualizarFugas(fuga.estacionId);
        } else {
            StopCargando();
        }
    };

    const handleEliminarFuga = async (id) => {
        const estacionSeleccionada = estaciones.find(e => e.id == fuga.estacionId);
        if (!estacionSeleccionada) return;

        Swal.fire({
            title: '¿Estás seguro?',
            text: "No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");
                const success = await EliminarFuga(estacionSeleccionada.endpoint, { id: id });
                StopCargando();
                if (success) {
                    Swal.fire(
                        'Eliminado!',
                        'El registro ha sido eliminado.',
                        'success'
                    )
                    const filtros = {};
                    if (filtroFechas.inicio && filtroFechas.fin) {
                        filtros.fecha_inicio = filtroFechas.inicio;
                        filtros.fecha_fin = filtroFechas.fin;
                    }
                    handleActualizarFugas(fuga.estacionId, filtros);
                }
            }
        })
    };

    return (
        <div>
            <div className="container-fluid py-4">

                {/* ======================== BOTONES SUPERIORES ======================== */}
                <div className="mb-3">
                    <button
                        className={`btn mb-3 ${selectedView === "precios" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("precios")}
                    >
                        <FaMoneyBill /> Precios
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "agregar" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("agregar")}
                    >
                        <FaPlus /> Agregar Combustible
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "fuga" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("fuga")}
                    >
                        <FaBook /> Registrar purga/corrida
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "estadisticas" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("estadisticas")}
                    >
                        <FaChartLine /> Estadísticas
                    </button>

                    <button
                        className={`btn mb-3 ms-2 ${selectedView === "reportes" ? "btn-success" : "btn-primary"}`}
                        onClick={() => setSelectedView("reportes")}
                    >
                        <FaFile /> Reportes
                    </button>
                </div>

                {/* PRECIOS */}
                {selectedView === "precios" && (
                    <>
                        {loading ? "Cargando..." : (

                            estaciones.map((estacion) => (
                                <div key={estacion.id} className="mb-3">
                                    <div
                                        onClick={() => handleToggle(estacion.id)}
                                        className="d-flex justify-content-between align-items-center p-3 border rounded cursor-pointer"
                                        style={{
                                            backgroundColor: '#f5f5f5',
                                            borderColor: '#ddd',
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                        }}
                                    >
                                        <span>{estacion.nombre}</span>
                                        <span>{expanded[estacion.id] ? '▲' : '▼'}</span>
                                    </div>

                                    {expanded[estacion.id] && (
                                        <div className="p-3 border mt-2" style={{ backgroundColor: '#fafafa' }}>
                                            {combustiblesPorEstacion[estacion.id] ? (
                                                combustiblesPorEstacion[estacion.id].length > 0 ? (
                                                    <Table bordered hover responsive className="table-custom">
                                                        <thead>
                                                            <tr className="table-light">
                                                                <th>Nombre</th>
                                                                <th>Precio</th>
                                                                <th>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {combustiblesPorEstacion[estacion.id].map(combustible => (
                                                                <tr key={combustible.id}>
                                                                    <td>{combustible.nombre}</td>
                                                                    <td>
                                                                        <Form.Control
                                                                            type="number"
                                                                            value={combustible.precio}
                                                                            onChange={(e) =>
                                                                                handlePrecioChange(estacion.id, combustible.id, e.target.value)
                                                                            }
                                                                            style={{
                                                                                borderColor: '#ddd',
                                                                                fontSize: '15.6px',
                                                                                backgroundColor: '#ffffff',
                                                                                transition: 'all 0.3s ease',
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <Button
                                                                            variant="danger"
                                                                            onClick={() => eliminarCombustible(estacion.endpoint, combustible.id)}
                                                                            style={{ borderRadius: '50px' }}
                                                                            title="Eliminar"
                                                                        >
                                                                            <FaTrash /> Eliminar
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </Table>
                                                ) : (
                                                    <p>No se encontraron combustibles.</p>
                                                )
                                            ) : (
                                                <p>Cargando combustibles...</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                        {loading ? "Cargando..." : (
                            <Button
                                variant="secondary"
                                onClick={() => handleActualizarPrecios()}
                            >
                                <FaSave /> Actualizar precios
                            </Button>
                        )}
                    </>
                )}

                {/* AGREGAR COMBUSTIBLE */}
                {selectedView === "agregar" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary mb-4">Agregar Nuevo TIPO de Combustible</h3>
                        <Form onSubmit={handleAgregarCombustible}>
                            <Form.Group className="mb-3">
                                <Form.Label>Estación</Form.Label>
                                <Form.Select
                                    value={nuevoCombustible.estacionId}
                                    onChange={(e) => setNuevoCombustible({ ...nuevoCombustible, estacionId: e.target.value })}
                                >
                                    <option value="">Seleccione una estación</option>
                                    {estaciones.map(estacion => (
                                        <option key={estacion.id} value={estacion.id}>
                                            {estacion.nombre}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Nombre del Combustible</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ej: Super, Premium, Diesel"
                                    value={nuevoCombustible.nombre}
                                    onChange={(e) => setNuevoCombustible({ ...nuevoCombustible, nombre: e.target.value })}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Precio</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="0.00"
                                    value={nuevoCombustible.precio}
                                    onChange={(e) => setNuevoCombustible({ ...nuevoCombustible, precio: e.target.value })}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" size="lg">
                                <FaSave /> Guardar Combustible
                            </Button>
                            {/* <div className="d-grid gap-2">

                            </div> */}
                        </Form>
                    </div>
                )}

                {/* FUGA */}
                {/* FUGA */}
                {selectedView === "fuga" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary mb-4">Registrar Purga / Corrida</h3>
                        <Form onSubmit={handleRegistrarFuga}>
                            <Form.Group className="mb-3">
                                <Form.Label>Estación</Form.Label>
                                <Form.Select
                                    value={fuga.estacionId}
                                    onChange={handleEstacionFugaChange}
                                >
                                    <option value="">Seleccione una estación</option>
                                    {estaciones.map(estacion => (
                                        <option key={estacion.id} value={estacion.id}>
                                            {estacion.nombre}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Manguera</Form.Label>
                                <Form.Select
                                    value={fuga.aforadorId}
                                    onChange={(e) => setFuga({ ...fuga, aforadorId: e.target.value })}
                                    disabled={!fuga.estacionId || mangueras.length === 0}
                                >
                                    <option value="">Seleccione una manguera</option>
                                    {mangueras.map(manguera => (
                                        <option key={manguera.id} value={manguera.id}>
                                            {manguera.manguera} - {manguera.tipocombustible} ({manguera.modulo} {manguera.sector})
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Volumen (Litros o m3)</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="0.00"
                                    value={fuga.cantidad}
                                    onChange={(e) => setFuga({ ...fuga, cantidad: e.target.value })}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit" size="lg">
                                <FaSave /> Guardar Registro
                            </Button>
                            {/* <div className="d-grid gap-2">
                                
                            </div> */}
                        </Form>

                        {fuga.estacionId ? (
                            <div className="mt-5">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h5 className="text-secondary m-0">Historial de Purgas / Corridas</h5>
                                        <small className="text-muted">{rangoMostrado}</small>
                                    </div>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => setMostrarFiltros(!mostrarFiltros)}
                                    >
                                        {mostrarFiltros ? 'Ocultar Filtros' : 'Filtrar por Fecha'}
                                    </Button>
                                </div>

                                {mostrarFiltros && (
                                    <div className="card p-3 mb-3 bg-light">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <Form.Group>
                                                    <Form.Label>Desde</Form.Label>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        value={filtroFechas.inicio}
                                                        onChange={(e) => setFiltroFechas({ ...filtroFechas, inicio: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-5">
                                                <Form.Group>
                                                    <Form.Label>Hasta</Form.Label>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        value={filtroFechas.fin}
                                                        onChange={(e) => setFiltroFechas({ ...filtroFechas, fin: e.target.value })}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-2 d-flex align-items-end">
                                                <Button variant="primary" className="w-100" onClick={handleFiltrarFugas}>
                                                    Buscar
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Manguera</th>
                                            <th>Combustible</th>
                                            <th>Volumen</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listaFugas.length > 0 ? (
                                            listaFugas.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{new Date(item.created_at).toLocaleString()}</td>
                                                    <td>{item.manguera}</td>
                                                    <td>{item.tipocombustible}</td>
                                                    <td>{item.purga}</td>
                                                    <td>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => handleEliminarFuga(item.id)}
                                                        >
                                                            <FaTrash />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No hay registros para mostrar ({rangoMostrado})</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        ) : null}
                    </div>
                )}

                {/* ESTADISTICAS */}
                {selectedView === "estadisticas" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary">Estadísticas del sistema</h3>
                        <center><p>Proximamente...</p></center>
                    </div>
                )}

                {/* REPORTES */}
                {selectedView === "reportes" && (
                    <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                        <h3 className="text-primary">Reportes</h3>
                        <center><p>Proximamente...</p></center>
                    </div>
                )}

            </div>
        </div>
    );
};
